"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const HighlightedIllustration_1 = __importDefault(require("./HighlightedIllustration"));
exports.default = HighlightedIllustration_1.default;
